module.exports = __webpack_public_path__ + "static/block2-628514dd665434bd7da7aac41a7ab891.jpg";